import { GET_EDUCATIONAL_PROGRAMS } from "../../../enums/Request/request.types";

export const getEducationalProgramsAction = (data) => {
    return {
        type: GET_EDUCATIONAL_PROGRAMS,
        payload: data,
    };
};
